module.exports = __webpack_public_path__ + "static/img/aboutUs14.44dfc35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs14.jpg
// module id = 1366
// module chunks = 1